<template>
<ion-app main>
  <ion-header>
    <ion-toolbar color="primary">
      <ion-buttons slot="start">
        <ion-button @click="openEnd">
          <ion-icon name="menu"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Usuario</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding" id="menucontent">
    <ion-list>
      <ion-item v-for="c in campos" :key="c.label">
        <ion-label text-wrap>{{c.label}}</ion-label>
        <ion-input v-if="['checkbox','select'].indexOf(c.type)==-1" :type="c.type" class="ion-text-right" color="primary" :value="usuario[c.name]" v-on:ionChange="set(c.name,$event.detail.value)"></ion-input>
        <ion-select v-if="c.type=='select'" :value="usuario[c.name]" v-on:ionChange="set(c.name,$event.detail.value)">
          <ion-select-option v-for="o in c.options" :key="o">{{o}}</ion-select-option>
        </ion-select>
        <ion-toggle slot="end" v-if="c.type=='checkbox'" :checked="usuario[c.name]" v-on:ionChange="set(c.name,($event.detail.checked==true))"></ion-toggle>
      </ion-item>
    </ion-list>
    <ion-fab horizontal="end" vertical="bottom" slot="fixed">
      <ion-fab-button color="primary" @click="guardar" :disabled="!(yo.rol=='administrador'||yo.permiso_editaUsuarios)">
        <i class="icon icon-lg ion-ios-save"></i>
      </ion-fab-button>
    </ion-fab>
  </ion-content>
</ion-app>
</template>
<script>
import Api from '@/components/Api/Api'
import sha1 from 'sha1'
export default {
  name: 'CatalogoUsuarios',
  props: {
    id: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      yo: Api.fetchLocal('cmms.yo') || {},
      usuario: {
        fecha: new Date().getTime()
      },
      campos: [{
        label: 'Nombre',
        name: 'nombre',
        type: 'text'
      }, {
        label: 'Email (inicio de sesión)',
        name: 'email',
        type: 'email'
      }, {
        label: 'Contraseña',
        name: 'password',
        type: 'password'
      }, {
        label: 'Rol',
        type: 'select',
        name: 'rol',
        options: ['administrador', 'supervisor', 'operador']
      }, {
        label: 'Gestiona catálogos',
        type: 'checkbox',
        name: 'permiso_gestionaCatalogos'
      }, {
        label: 'Crea órdenes de servicio',
        type: 'checkbox',
        name: 'permiso_creaOrdenesServicio'
      }, {
        label: 'Asignar órdenes a otros usuarios',
        type: 'checkbox',
        name: 'permiso_asignarOrdenesServicio'
      }, {
        label: 'Cancelar órdenes de servicio',
        type: 'checkbox',
        name: 'permiso_cancelaOrdenesServicio'
      }, {
        label: 'Modificar usuarios (ignorada siendo administrador)',
        type: 'checkbox',
        name: 'permiso_editaUsuarios'
      }, {
        label: 'Eliminar clientes',
        type: 'checkbox',
        name: 'permiso_eliminaClientes'
      }, {
        label: 'Visualiza reportes',
        type: 'checkbox',
        name: 'permiso_visualizaReportes'
      }, {
        label: 'Visualiza costos y precios',
        type: 'checkbox',
        name: 'permiso_visualizaCostos'
      }]
    }
  },
  methods: {
    openEnd() {
      Api.$emit('open-menu')
    },
    async obtener() {
      if (this.id && this.id != '' && this.id != '0')
        this.usuario = await Api.get('directorio', this.id)
      console.log("Usuario", this.id, this.usuario.nombre, this.usuario.password.length)
    },
    set(campo, valor) {
      console.log("set", campo, valor)
      this.usuario[campo] = valor
      if (campo == 'rol' && valor == 'administrador') {
        for (let campo of this.campos)
          if (campo.name.startsWith('permiso'))
            this.usuario[campo] = true
      }
      this.$forceUpdate()
    },
    async guardar() {
      if ((this.usuario.password || '').length != 40)
        this.usuario.password = sha1(this.usuario.password)
      await Api.save('directorio', this.usuario)
      toast("Guardado")
      this.$router.push('/catalogos/usuarios')
    }
  },
  mounted() {
    this.obtener()
  }
}
</script>
